export default __webpack_public_path__ + "static/media/services_custom_software_development_blur.c12948dd.png";